import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const zoeOrdersService = {
  async getList(page = 1, limit = 20) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({ offset, limit });

    return (
      await api_fetch.get(
        `/v1/zoe-orders?${params.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async searchByListField(
    filters = {},
    page = 1,
    sortBy,
    sortOrder,
    limit = 20
  ) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams();

    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    if (
      sortBy &&
      sortOrder &&
      sortBy !== 'default' &&
      sortOrder !== 'default'
    ) {
      params.append('sort_by', sortBy);
      params.append('sort_order', sortOrder);
    }

    const response = await api_fetch.get(
      `/v1/zoe-orders/search?${params.toString()}`,
      {
        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
      },
      {}
    );

    return response.json();
  },

  async getZoeOrder(id) {
    return (
      await api_fetch.get(
        `/v1/zoe-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async createZoeOrder(data) {
    return (
      await api_fetch.post(
        `/v1/zoe-orders`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        data
      )
    ).json();
  },

  async updateZoeOrder(id, data) {
    return (
      await api_fetch.put(
        `/v1/zoe-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        data
      )
    ).json();
  },

  async deleteZoeOrder(id) {
    return (
      await api_fetch.delete(
        `/v1/zoe-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        // api_fetch.delete concatenates url + params + query; omitting
        // the 4th argument produced "/v1/zoe-orders/<id>undefined".
        '',
        {}
      )
    ).json();
  },

  async addTrackingNumbers(id, trackingNumbers) {
    return (
      await api_fetch.post(
        `/v1/zoe-orders/${id}/tracking`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        { trackingNumbers }
      )
    ).json();
  },

  async removeTrackingNumbers(id, trackingNumbers) {
    return (
      await api_fetch.delete(
        `/v1/zoe-orders/${id}/tracking`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        { trackingNumbers }
      )
    ).json();
  },

  async getPurchaseOrder(id) {
    return (
      await api_fetch.get(
        `/v1/zoe-orders/${id}/purchase-order`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  }
};


export default zoeOrdersService;
